(function configureHypersceneRuntime(globalScope) {
  const hostName = globalScope.location?.hostname?.toLowerCase();
  const localHostNames = new Set(['localhost', '127.0.0.1', '::1']);

  globalScope.__HYPERSCENE_RUNTIME_CONFIG__ = {
    apiBaseUrl: hostName && !localHostNames.has(hostName) ? `https://api.${hostName}` : '',
  };
})(globalThis);
